import { render, staticRenderFns } from "./InputOrientation.vue?vue&type=template&id=b4119644&scoped=true"
import script from "./InputOrientation.vue?vue&type=script&lang=js"
export * from "./InputOrientation.vue?vue&type=script&lang=js"
import style0 from "./InputOrientation.vue?vue&type=style&index=0&id=b4119644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4119644",
  null
  
)

export default component.exports